
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6347_7844)"}},[_c('path',{staticClass:"icon-path",attrs:{"d":"M14 28.5c7.732 0 14-6.268 14-14S21.732.5 14 .5 0 6.768 0 14.5s6.268 14 14 14z","fill":"#AF3ED8"}}),_c('path',{attrs:{"d":"M20.1 13.98a.6.6 0 010 1.04l-8.7 5.022a.6.6 0 01-.9-.52V9.478a.6.6 0 01.9-.52l8.7 5.023z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6347_7844"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h28v28H0z"}})])])])
          )
        }
      }
    